import { Box, BoxProps } from '@mui/material';
import React from 'react';

import { LinkChipProps, LinkChip } from './LinkChip';

export type ChipLinkBoxProps = {
  items: LinkChipProps[];
  chipIcon?: React.ComponentType;
} & Omit<BoxProps, 'onClick'>;

export const ChipLinkBox = ({ items, chipIcon, ...restProps }: ChipLinkBoxProps) => {
  return (
    <Box display='flex' flexWrap='wrap' overflow='hidden' gap={1} {...restProps}>
      {items.map((item) => (
        <LinkChip key={item.href} href={item.href} label={item.label} chipIcon={chipIcon} />
      ))}
    </Box>
  );
};
